import React, { useId, useState } from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function ClientReportInfo({ label, children }) {
  const [anchor, setAnchor] = useState(null);
  const id = useId();
  return (
    <>
      <IconButton
        size="small"
        aria-label={label}
        aria-haspopup="dialog"
        aria-expanded={Boolean(anchor)}
        aria-controls={anchor ? id : undefined}
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{ color: '#64748b', width: 32, height: 32, verticalAlign: 'middle', flexShrink: 0 }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{ role: 'dialog', id, 'aria-label': label, sx: { maxWidth: 340, p: 1.5, color: '#334155', bgcolor: '#fff', textAlign: 'left' } }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 0.5 }}>
          <Typography sx={{ fontSize: '0.8rem', fontWeight: 700 }}>{label}</Typography>
          <IconButton size="small" aria-label="Close explanation" onClick={() => setAnchor(null)}><CloseRoundedIcon fontSize="small" /></IconButton>
        </Box>
        <Typography component="div" sx={{ fontSize: '0.78rem', lineHeight: 1.5 }}>{children}</Typography>
      </Popover>
    </>
  );
}
